import { Separator } from './separator';
import React from 'react';

interface TextSeparatorProps {
  text: string;
  className?: string;
  textClassName?: string;
}

export const TextSeparator = ({
  className,
  textClassName,
  text,
}: TextSeparatorProps) => {
  return (
    <div className={`relative flex items-center w-full ${className}`}>
      <Separator className="w-full absolute" />
      <span
        className={`px-2 text-sm text-muted-foreground bg-background relative mx-auto ${textClassName}`}
      >
        {text}
      </span>
    </div>
  );
};
